export default function getCarouselImages(product) {
  const content = product?.content;
  if (!content) {
    return [];
  }

  return [
    content.carouselImage1,
    content.carouselImage2,
    content.carouselImage3
  ].filter(url => url);
}
